import { initSentry } from '@hh.ru/front-static-app';

import serviceName from 'src/modules/serviceName';

/* eslint-disable-next-line */
import 'src/styles/global.less';

initSentry(serviceName);

const init = require('src/app/App').default;

export default init;
